import ApolloClient from 'apollo-client'
import { WebSocketLink } from 'apollo-link-ws';
import { InMemoryCache } from "apollo-cache-inmemory";

const getHeaders = () => {
  const headers = {};
  const token = window.localStorage.getItem('apollo-token');
  if (token) {
    headers.authorization = `Bearer ${token}`;
  }
  return headers;
};

// Create a WebSocket link:
const link = new WebSocketLink({
  uri: 'wss://hasura-otti.rover.otti.io/v1/graphql',
  options: {
    reconnect: true,
    timeout: 2000,
    connectionParams: () => {
      return { headers: getHeaders() };
    },
  }
});

const apolloClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache({
    addTypename: true
  })
})

export default apolloClient